/**
 * pushSubscriptionService.js
 * Handles all HTTP calls related to Web Push subscriptions.
 */

const BASE_URL = process.env.REACT_APP_BACKEND_URL || "http://localhost:1338/api/";

function getAuthHeader() {
  const token = localStorage.getItem("auth_token");
  return token ? { Authorization: `Bearer ${token}` } : {};
}

/** Fetch the VAPID public key from the server. */
export async function fetchVapidPublicKey() {
  const res = await fetch(`${BASE_URL}push/vapid-public-key`);
  const json = await res.json();
  if (!json.success) throw new Error("Failed to fetch VAPID public key");
  return json.publicKey;
}

/** Send a new push subscription to the server. */
export async function registerPushSubscription(userId, subscription) {
  const res = await fetch(`${BASE_URL}push/subscribe`, {
    method: "POST",
    headers: { "Content-Type": "application/json", ...getAuthHeader() },
    body: JSON.stringify({ userId, subscription: subscription.toJSON() }),
  });
  const json = await res.json();
  if (!json.success) throw new Error(json.message || "Subscribe failed");
  return json;
}

/** Remove a push subscription from the server. */
export async function unregisterPushSubscription(endpoint) {
  const res = await fetch(`${BASE_URL}push/unsubscribe`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ endpoint }),
  });
  return res.json();
}
